import React from "react";
import { Card } from "react-bootstrap";

import { englishNumbersToPersian } from "core/utils/englishNumbersToPersian";
import OpenItemButton from "components/common/Buttons/OpenItemButton/OpenItemButton";

import "./NewsGridFlashCard.scss";
const NewsGridFlashCard = ({ title, subTitle, img, id, date }) => {
  return (
    <Card className="news-grid-card-item">
      <Card.Img
        className="photo-news-image"
        variant="top"
        src={`${process.env.REACT_APP_PUBLIC_PATH}/${img}`}
      />
      <Card.Body>
        <Card.Title className="truncate">{title}</Card.Title>
        <span className="news-grid-flash-card-date">
          {englishNumbersToPersian(date)}
        </span>
        <OpenItemButton text="مشاهده ادامه خبر" />
      </Card.Body>
    </Card>
  );
};
export default NewsGridFlashCard;
